// Types
import { ApiRequest, State } from 'types'
import { ApiRequestDefaultValues } from 'modules/requests/models'

export const selectRequest = (state: State, actionType: string, key?: string | number): ApiRequest => {
  const type = state.requests[actionType]
  const request = type && type[key ? String(key) : 'default']
  return request || ApiRequestDefaultValues
}
